module.exports = "../../../../platform/assets/pageMainIcon/baobiaochaxunlei3.svg";